import { render, staticRenderFns } from "./ChipCenter.vue?vue&type=template&id=8a711096"
import script from "./ChipCenter.vue?vue&type=script&lang=js"
export * from "./ChipCenter.vue?vue&type=script&lang=js"
import style0 from "./ChipCenter.vue?vue&type=style&index=0&id=8a711096&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports